<template>
    <div class="new-list-group-item">

        <div class="row" v-if="editingId == question.id">

            <div class="col-2 align-items-start" style="font-size: 18px;">
            </div>
            <div class="col-9 align-items-start">
                <textarea class="form-control" style="height: 86px;" v-model="title"></textarea>
            </div>
            <div class="col-10 align-items-start">
                <textarea class="form-control" style="height: 260px;" v-model="answer"></textarea>
            </div>
            <div class="col-3 d-flex justify-content-end align-items-start">
                <button class="btn btn-primary btn-sm me-1" :disabled="patcher.submitted" @click="patcherPatch()">
                    <span class="spinner-border spinner-border-sm"></span>
                    Spara
                </button>
                <button class="btn btn-danger btn-sm" disabled>
                    <img src="/images/admin/icon-trash.svg">
                </button>
            </div>

        </div>

        <div class="row" v-else>
            <div class="col-2 align-items-start" style="font-size: 18px;">
                <span class="fa fa-arrow-down" @click="reOrder(nextQuestion.order)" v-if="nextQuestion"></span>
                <span class="fa fa-arrow-up" @click="reOrder(previousQuestion.order)" v-if="previousQuestion"></span>
            </div>
            <div class="col-9 align-items-start">
                <span>{{ title }}</span>
            </div>
            <div class="col-10 align-items-start">
                <span>{{ shortAnswer }}</span>
            </div>
            <div class="col-3 d-flex justify-content-end align-items-start">
                <button class="btn btn-primary btn-sm me-1" @click="editingId = question.id">
                    <span class="spinner-border spinner-border-sm"></span>
                    Ändra
                </button>
                <button class="btn btn-danger btn-sm" :disabled="deleter.submitted" @click="triggerDelete()">
                    <img src="/images/admin/icon-trash.svg">
                </button>
            </div>
        </div>

    </div>
</template>

<script>
import patcher from '../../../shared/mixins/patcher'
import deleter from '../../../shared/mixins/deleter'

export default {

    mixins: [
        patcher,
        deleter
    ],

    props: {
        question: {
            required: true
        },
        previousQuestion: {
            required: true
        },
        nextQuestion: {
            required: true
        }
    },

    data () {
        return {
            title: this.question.title,
            answer: this.question.answer,
            order: this.question.order,
            editingId:0
        }
    },

    computed: {
        deleterUrl () {
            return '/faq-pages/' + this.question.id
        },
        patcherUrl () {
            return '/faq-pages/' + this.question.id
        },
        patcherData () {
            return {
                title: this.title,
                answer: this.answer,
                order: this.order
            }
        },
        shortAnswer () {

            if(this.answer)
            {
                if(this.answer.length > 100)
                {
                    return this.answer.substr(100)+"..."
                }
                return this.answer  
            }
            
        }
    },

    methods: {

        reOrder (newOrder) {
            this.order = newOrder
            this.patcherPatch()
        },

        triggerDelete () {
            if (!confirm('Vill du verkligen radera frågan och svaret?')) {
                return
            }
            this.deleterDelete()
        },

        patcherSuccess () {
            bus.$emit(
                'notify',
                'Frågan har uppdaterats.'
            )

            this.$emit('refresh')
            this.editingId = 0
        },

        deleterSuccess () {
            bus.$emit(
                'notify',
                'Frågan har raderats.'
            )

            this.$emit('refresh')
        }
    }
}
</script>
